import Proptypes from 'prop-types';
import React from 'react';

const Calendar = ({ height = '28', width = '29' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 28 29"
    fill="none"
    xmlns="https://www.w3.org/2000/svg"
  >
    <path
      className="college-branded-icon-stroke"
      d="M5.26851 3.02087H0.791321V28.3959H26.5352V3.02087H22.058"
      stroke="#006894"
      strokeWidth="1.25"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      className="college-branded-icon-stroke"
      d="M8.62639 0.604187H5.26849V5.43752H8.62639V0.604187Z"
      stroke="#006894"
      strokeWidth="1.25"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      className="college-branded-icon-stroke"
      d="M22.058 0.604187H18.7001V5.43752H22.058V0.604187Z"
      stroke="#006894"
      strokeWidth="1.25"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      className="college-branded-icon-stroke"
      d="M8.6264 3.02087H18.7001"
      stroke="#006894"
      strokeWidth="1.25"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      className="college-branded-icon-stroke"
      d="M0.791321 9.0625H26.5352"
      stroke="#006894"
      strokeWidth="1.25"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      className="college-branded-icon-stroke"
      d="M7.50714 11.4792V25.9792"
      stroke="#006894"
      strokeWidth="1.25"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      className="college-branded-icon-stroke"
      d="M13.6633 11.4792V25.9792"
      stroke="#006894"
      strokeWidth="1.25"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      className="college-branded-icon-stroke"
      d="M19.8194 11.4792V25.9792"
      stroke="#006894"
      strokeWidth="1.25"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      className="college-branded-icon-stroke"
      d="M3.02991 13.8959H24.2966"
      stroke="#006894"
      strokeWidth="1.25"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      className="college-branded-icon-stroke"
      d="M3.02991 18.7292H24.2966"
      stroke="#006894"
      strokeWidth="1.25"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      className="college-branded-icon-stroke"
      d="M3.02991 23.5625H24.2966"
      stroke="#006894"
      strokeWidth="1.25"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

Calendar.propTypes = {
  height: Proptypes.string,
  width: Proptypes.string,
};

export default Calendar;
